module.exports = __webpack_public_path__ + "img/EntitiesActive.8af5bf24.svg";